(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("simple-json-api-resource-seralizer", [], factory);
	else if(typeof exports === 'object')
		exports["simple-json-api-resource-seralizer"] = factory();
	else
		root["simple-json-api-resource-seralizer"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _json_api_resource_serializer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./json-api-resource-serializer */ "./src/json-api-resource-serializer.js");

/* harmony default export */ __webpack_exports__["default"] = (_json_api_resource_serializer__WEBPACK_IMPORTED_MODULE_0__["default"]);

/***/ }),

/***/ "./src/json-api-resource-serializer.js":
/*!*********************************************!*\
  !*** ./src/json-api-resource-serializer.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import pluralize from 'pluralizer';
var ensureAttribute = function ensureAttribute(name, object) {
  if (object == null || name in object === false) {
    throw new Error("'".concat(name, "' property was not found in object and is required"));
  }
};

var JsonApiResourceSerializer =
/*#__PURE__*/
function () {
  function JsonApiResourceSerializer() {
    var _this = this;

    _classCallCheck(this, JsonApiResourceSerializer);

    _defineProperty(this, "isNonEmptyRelationship", function (relationship) {
      return relationship.data != null && (Array.isArray(relationship.data) || Object.keys(relationship.data).length > 0);
    });

    _defineProperty(this, "nonEmptyRelationships", function (relationships) {
      return relationships.filter(function (r) {
        return _this.isNonEmptyRelationship(r);
      });
    });

    _defineProperty(this, "recordsForType", function (type, records) {
      return records.filter(function (r) {
        return r.type === type;
      });
    });

    _defineProperty(this, "deserializeCollection", function (collection, payload) {
      return collection.map(function (i) {
        return _this.deserializeItem(i, payload);
      });
    });
  }

  _createClass(JsonApiResourceSerializer, [{
    key: "deserializeAttributes",
    value: function deserializeAttributes(container, item) {
      return _objectSpread({}, container, {
        type: item.type
      }, item.attributes, {
        id: item.id
      });
    }
  }, {
    key: "resolveRelationship",
    value: function resolveRelationship(relationship, records, payload) {
      if (!payload) throw new Error('Payload is required');
      ensureAttribute('type', relationship);
      ensureAttribute('id', relationship);
      var record = this.deserializeItem(records.find(function (r) {
        return r.type === relationship.type && r.id === relationship.id;
      }), payload);
      return record;
    }
  }, {
    key: "mapRelationship",
    value: function mapRelationship(relationship, payload) {
      var _this2 = this;

      if (!relationship.data) return null;
      ensureAttribute('data', relationship);
      ensureAttribute('included', payload);
      var data = relationship.data;

      if (Array.isArray(data)) {
        return data.map(function (r) {
          return _this2.resolveRelationship(r, _this2.recordsForType(r.type, payload.included), payload);
        });
      }

      if (data == null || Array.isArray(data) && data.length === 0 || Object.keys(data).length === 0) {
        return null;
      }

      return this.resolveRelationship(data, this.recordsForType(relationship.data.type, payload.included), payload);
    }
  }, {
    key: "mapRelationships",
    value: function mapRelationships(item, payload) {
      var _this3 = this;

      if ('relationships' in item === false) return {};
      if (!payload) throw new Error('mapRelationships requires a Payload');
      var relationships = item.relationships;
      return Object.keys(relationships).map(function (key) {
        return {
          key: key,
          data: _this3.mapRelationship(relationships[key], payload)
        };
      }).reduce(function (prev, curr) {
        prev[curr.key] = curr.data;
        return prev;
      }, {});
    }
  }, {
    key: "deserializeItem",
    value: function deserializeItem(item, payload) {
      if (!payload) throw new Error('A payload is required.');
      if (!item) return {};
      return _objectSpread({}, this.deserializeAttributes({}, item), this.mapRelationships(item, payload));
    }
  }, {
    key: "deserialize",
    value: function deserialize(payload) {
      if (!payload) throw new Error('A payload is required');
      ensureAttribute('data', payload);
      return this[Array.isArray(payload.data) ? 'deserializeCollection' : 'deserializeItem'](payload.data, payload);
    }
  }]);

  return JsonApiResourceSerializer;
}();

/* harmony default export */ __webpack_exports__["default"] = (JsonApiResourceSerializer);

/***/ })

/******/ });
});
//# sourceMappingURL=simple-json-api-resource-seralizer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/simple-json-api-resource-seralizer/lib/simple-json-api-resource-seralizer.js
// module id = 494
// module chunks = 0 15 16 17